export default __webpack_public_path__ + "static/media/logo-white.d074404c.svg";